import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { Link } from "react-router-dom";
import helpersNumbers from "../../../../../helpers/numbers";
import validateFormsAddGiftChargeUser from "../../../../../validtions/forms/gift-charge-user/add";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersTime from "../../../../../helpers/time";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function Edit() {
  const params = useParams();
  const giftID = params.giftChargeUserID;

  const [activeLimitMaxCountUseGift, setActiveLimitMaxCountUseGift] =
    useState(false);
  const [
    activeLimitMaxCountUseGiftViaUsers,
    setActiveLimitMaxCountUseGiftEachUser,
  ] = useState(false);

  const history = useHistory();
  const [gift, setGift] = useState();

  useEffect(() => {
    getGift();
  }, []);

  useEffect(() => {
    if (!gift) {
      return;
    }
    setActiveLimitMaxCountUseGift(() => {
      return gift.conditions.max_count_use_gift == 0 ? true : false;
    });

    setActiveLimitMaxCountUseGiftEachUser(() => {
      return gift.conditions.max_count_use_each_user == 0 ? true : false;
    });
  }, [gift]);

  const getGift = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetGift = await sendRequestGetGift();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetGift) {
      return;
    }

    setGift(resultSendRequestGetGift);
  };

  const sendRequestGetGift = async () => {
    let headersRequest = getHeaderForRequest();
    let gift;
    try {
      gift = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/gift-charge/${giftID}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return gift.data.data;
  };

  const [message, setMessage] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const getStartDate = () => {
    return `${helpersTime.convertJalaliToGregorian(
      document.querySelector("#start-date input").value
    )} ${document.querySelector("#hour-start-date").value}:${
      document.querySelector("#minute-start-date").value
    }`;
  };

  const getEndDate = () => {
    return `${helpersTime.convertJalaliToGregorian(
      document.querySelector("#end-date input").value
    )} ${document.querySelector("#hour-end-date").value}:${
      document.querySelector("#minute-end-date").value
    }`;
  };

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".content-wrapper");
    element.scrollIntoView();
  };

  const sendForm = async () => {
    const formData = getDataForm();
    const resultValidateFormsAddGiftChargeUser =
      validateFormsAddGiftChargeUser(formData);
    if (resultValidateFormsAddGiftChargeUser != true) {
      setMessage({
        type_class: "alert alert-danger ",
        text: resultValidateFormsAddGiftChargeUser,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultAddGiftChargeUser = await sendRequestEditGiftChargeUser(
      formData
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultAddGiftChargeUser) {
      return;
    }
    history.push(`/finance/manage/gift-charge-user/all`);
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestEditGiftChargeUser = async (bodyRequest) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/gift-charge/${giftID}`,
        bodyRequest,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger ",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return false;
    }
    return true;
  };

  const getDataForm = () => {
    const maxCountUseDiscount =
      activeLimitMaxCountUseGift === false
        ? document.querySelector("#max-count-use-gift").value
        : "0";
    const maxCountUseViaUsers =
      activeLimitMaxCountUseGiftViaUsers === false
        ? document.querySelector("#max-count-use-each-user").value
        : "0";
    return {
      amount: document.querySelector("#amount").value,
      description: document.querySelector("#description").value,
      start_date: getStartDate(),
      end_date: getEndDate(),
      max_count_use_gift: maxCountUseDiscount,
      max_count_use_each_user: maxCountUseViaUsers,
    };
  };

  const generateGiftForm = () => {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          sendForm();
        }}
      >
        <div className="form-group py-2 text-right">
          <label>توضیحات تخفیف</label>
          <textarea className="form-control" rows="5" id="description" required>
            {gift.description}
          </textarea>
        </div>
        <div className="form-group py-2">
          <div className="d-flex align-items-center">
            <span className="pl-2">
              <label className="m-0">مقدار تخفیف درصد</label>
            </span>
          </div>
          <div>
            <div className="input-group">
              <input
                type="number"
                min="1"
                max="99"
                id="amount"
                className="form-control number-finance"
                dir="ltr"
                defaultValue={gift.amount}
                onWheel={(event) => event.currentTarget.blur()}
                required
              />
            </div>
          </div>
        </div>

        <div className="form-group py-2">
          <div>
            <div className="d-flex">
              <label className="text-nowrap">
                شرط تاریخ و ساعت شروع استفاده از هدیه افزایش اعتبار (ساعت را ۲۴
                ساعته وارد کنید)
              </label>
            </div>
          </div>
          <div className="d-flex align-items-center">
            <div id="start-date" className="custom-data-picker">
              <DatePicker
                placeholder="انتخاب تاریخ"
                format="jYYYY/jMM/jDD"
                preSelected={helpersTime.convertGregorianToJalali(
                  gift.start_date.split("_")[0]
                )}
              />
            </div>
            <div className="text-nowrap pr-2">ساعت :</div>
            <div className="px-2">
              <input
                className="form-control"
                type="number"
                id="hour-start-date"
                min="0"
                max="23"
                onWheel={(event) => event.currentTarget.blur()}
                defaultValue={gift.start_date.split(" ")[1].split(":")[0]}
                required
              />
            </div>
            <div className="text-nowrap">دقیقه :</div>
            <div className="pr-2">
              <input
                className="form-control"
                type="number"
                id="minute-start-date"
                min="0"
                max="59"
                onWheel={(event) => event.currentTarget.blur()}
                defaultValue={gift.start_date.split(" ")[1].split(":")[1]}
                required
              />
            </div>
          </div>
        </div>
        <div className="form-group py-2">
          <div className="d-flex">
            <label className="text-nowrap">
              شرط تاریخ و ساعت پایان استفاده از هدیه افزایش اعتبار (ساعت را ۲۴
              ساعته وارد کنید)
            </label>
          </div>
          <div className="d-flex align-items-center">
            <div id="end-date" className="custom-data-picker">
              <DatePicker
                placeholder="انتخاب تاریخ"
                format="jYYYY/jMM/jDD"
                preSelected={helpersTime.convertGregorianToJalali(
                  gift.end_date.split("_")[0]
                )}
              />
            </div>
            <div className="text-nowrap pr-2">ساعت :</div>
            <div className="px-2">
              <input
                className="form-control"
                type="number"
                id="hour-end-date"
                min="0"
                max="23"
                onWheel={(event) => event.currentTarget.blur()}
                defaultValue={gift.end_date.split(" ")[1].split(":")[0]}
                required
              />
            </div>
            <div className="text-nowrap">دقیقه :</div>
            <div className="pr-2">
              <input
                className="form-control"
                type="number"
                id="minute-end-date"
                min="0"
                max="59"
                onWheel={(event) => event.currentTarget.blur()}
                defaultValue={gift.end_date.split(" ")[1].split(":")[1]}
                required
              />
            </div>
          </div>
        </div>

        <div className="form-group py-2">
          <div className="d-flex pb-2">
            <label>شرط محدودیت بیشترین استفاده هدیه افزایش اعتبار</label>
            <span className="d-flex bg-warning  p-1 rounded align-self-start">
              <div className="text-nowrap pr-2">
                استفاده کردن به شکل نامحدود :
              </div>
              <div className="pr-2">
                <span>
                  <label className="adl-switch">
                    <input
                      type="checkbox"
                      checked={activeLimitMaxCountUseGift}
                      onChange={() => {
                        setActiveLimitMaxCountUseGift(
                          (prevState) => !prevState
                        );
                      }}
                    />
                    <span className="adl-slider round"></span>
                  </label>
                </span>
              </div>
            </span>
          </div>
          <input
            type="number"
            id="max-count-use-gift"
            className="form-control"
            disabled={activeLimitMaxCountUseGift}
            onWheel={(event) => event.currentTarget.blur()}
            defaultValue={
              gift.conditions.max_count_use_gift == 0
                ? ""
                : gift.conditions.max_count_use_gift
            }
            required
          />
        </div>

        <div className="form-group py-2">
          <div className="d-flex pb-2">
            <label>
              شرط محدودیت بیشترین استفاده هدیه افزایش اعتبار هر کاربر
            </label>

            <span className="d-flex bg-warning  p-1 rounded align-self-start">
              <div className="text-nowrap pr-2">
                استفاده کردن به شکل نامحدود :
              </div>

              <div className="pr-2">
                <span>
                  <label className="adl-switch">
                    <input
                      type="checkbox"
                      checked={activeLimitMaxCountUseGiftViaUsers}
                      onChange={(e) => {
                        setActiveLimitMaxCountUseGiftEachUser(
                          (prevState) => !prevState
                        );
                      }}
                    />
                    <span className="adl-slider round"></span>
                  </label>
                </span>
              </div>
            </span>
          </div>
          <input
            type="number"
            id="max-count-use-each-user"
            className="form-control"
            disabled={activeLimitMaxCountUseGiftViaUsers}
            onWheel={(event) => event.currentTarget.blur()}
            defaultValue={
              gift.conditions.max_count_use_each_user == 0
                ? "1"
                : gift.conditions.max_count_use_each_user
            }
            required
          />
        </div>

        <div className="form-group text-right py-2">
          <button className="btn btn-success">ویرایش هدیه </button>
        </div>
      </form>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  اضافه کردن هدیه افزایش اعتبار
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to="/finance/manage/gift-charge-user/all"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
                {gift && generateGiftForm()}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
